/**
 * Shared filtering/sorting helpers for the product listing pages
 * (AllProduct + per-category ProductPage). Operates on the normalized
 * card shape used by those pages: { name, price, issoldout, ... }.
 */

// Price buckets in £ (max is exclusive; Infinity = open-ended top bucket).
export const PRICE_BUCKETS = [
  { id: 'u5', label: 'Under £5', min: 0, max: 5 },
  { id: '5-10', label: '£5 - £10', min: 5, max: 10 },
  { id: '10-20', label: '£10 - £20', min: 10, max: 20 },
  { id: '20-50', label: '£20 - £50', min: 20, max: 50 },
  { id: '50p', label: '£50+', min: 50, max: Infinity },
];

export const SORT_OPTIONS = [
  { id: 'featured', label: 'Featured' },
  { id: 'price-asc', label: 'Price: Low to High' },
  { id: 'price-desc', label: 'Price: High to Low' },
  { id: 'name-asc', label: 'Name: A - Z' },
];

const inBucket = (p, b) => {
  const price = Number(p.price);
  return !Number.isNaN(price) && price >= b.min && price < b.max;
};

/** Only the price buckets that actually contain at least one product. */
export function availableBuckets(list) {
  return PRICE_BUCKETS.filter((b) => list.some((p) => inBucket(p, b)));
}

/** Apply price-range filter, then sort. Returns a new array. */
export function applyCatalogFilters(list, { sortBy = 'featured', priceBucket = 'all' } = {}) {
  let out = (list || []).filter(Boolean);
  if (priceBucket !== 'all') {
    const b = PRICE_BUCKETS.find((x) => x.id === priceBucket);
    if (b) out = out.filter((p) => inBucket(p, b));
  }
  out = [...out];
  switch (sortBy) {
    case 'price-asc': out.sort((a, b) => Number(a.price) - Number(b.price)); break;
    case 'price-desc': out.sort((a, b) => Number(b.price) - Number(a.price)); break;
    case 'name-asc': out.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))); break;
    default: break;
  }
  return out;
}
